// --------------------------------------------------------------
// Created On: 2023-02-17
// Author: Zachary Thomas
//
// Last Modified: 2025-11-06
// Modified By: Zachary Thomas
//
// Copyright 2024 - 2025 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

import React, { Fragment } from "react";
import { PRIVACY_POLICY } from "../../constants/miscellaneous";
import Card from "../../components/Card/Card";
import styles from "./PolicyPage.module.scss";
import DangerousHtmlContent from "./DangerousHtmlContent/DangerousHtmlContent";
import { Link } from "react-router-dom";

// Page for viewing policy PDFs.
export default function PolicyPage(props: Props): Component {
  const alternateDisplayUrl = getAlternateDisplayUrl(props.policyType, props.displayType);

  // Get the correct URL for the alternate display option.
  function getAlternateDisplayUrl(policyType: "Privacy Policy", displayType: "text" | "pdf"): string {
    if (policyType === "Privacy Policy" && displayType === "pdf") {
      return "/privacy-policy-text";
    } else {
      return "/privacy-policy-viewer";
    }
  }

  return (
    <div className={`${styles.body} p-4`} data-test="policy-card">
      <Card title={props.policyType} fullWidth>
        <div className={`${styles.buttonHeader} pt-1 pb-4`}>
          <Link className="m-2" to={alternateDisplayUrl}>
            <button className="btn btn-primary" data-test="switch-legal-display-button">
              {props.displayType === "text" ? "Switch to PDF Viewer" : "Switch to Plain Text"}
            </button>
          </Link>
        </div>

        {props.displayType === "pdf" ? (
          <div className={styles.cardInterior}>
            <object data={PRIVACY_POLICY} type="application/pdf" width="100%" height="100%">
              <p>PDF URL: &qt;{props.policyType === "Privacy Policy" && PRIVACY_POLICY}&qt;</p>
            </object>
          </div>
        ) : (
          <Fragment>
            {props.policyType === "Privacy Policy" && <DangerousHtmlContent fileUrl="/legal/Privacy_Policy.html" />}
          </Fragment>
        )}
      </Card>
    </div>
  );
}

interface Props {
  policyType: "Privacy Policy";
  displayType: "text" | "pdf";
}
